export const BILLING_OWNER_ONLY_MESSAGE = "Billing is managed by your account owner.";

// Keep the Team Access request test unchanged; billing routes share it here.
export function isTeamMemberBillingRequest(req: {
  user?: { isSecondaryMember?: unknown };
  authIdentity?: { isTeamMember?: unknown };
}): boolean {
  return !!(req.user?.isSecondaryMember || req.authIdentity?.isTeamMember);
}

// Used only for read-only member displays; owner's existing screens stay intact.
export function getBillingPlanName(user: {
  membershipTier?: string | null;
  userType?: string | null;
} | null | undefined): string {
  const tier = user?.membershipTier || "Free";
  if (!["Paid", "Annual", "SearchAndBid"].includes(tier)) return tier;
  if (user?.userType === "Shipper") return "Shipper Unlimited";
  if (user?.userType === "Carrier") return "Carrier Search & Bid";
  if (user?.userType === "Broker") {
    return tier === "SearchAndBid" ? "Broker Search & Bid" : "Broker Search, Bid & Post";
  }
  return tier;
}
